export const createAccount = `
    mutation createAccount($input: CreateAccountInput!) {
        createAccount(input:$input) {
            id
            name
            email
            accountType
            status
            organizationId
    }
}`;

export const updateAccount = `
    mutation updateAccount($input: UpdateAccountInput!) {
        updateAccount(input:$input){
            id
            sub
            username
            email
            accountType
            accountStatus
            customerId
            created
            updated
        }
}`;


// FNP-117: deleteAccount is the canonical user-facing entrypoint after FNP-285.
// It is a soft-delete: flips accountStatus to PENDING_DELETION, sets retention
// metadata, and emits `account-removal-requested` for the workflows-api
// playbook (FNP-360). Idempotent on the backend via DDB ConditionExpression.
export const deleteAccount = `
    mutation deleteAccount($input: DeleteAccountInput!) {
        deleteAccount(input: $input) {
            id
            accountStatus
            deletionRequestedAt
            deletionRequestedBy
            scheduledHardDeleteAt
        }
}`;
